module.exports = __webpack_public_path__ + "c32b8438cebc2acf3667a16eafa71400.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-38@2x.png
// module id = 515
// module chunks = 0